<div class="p-4 main-container">
  <div class="p-3 w-100">
    <div class="d-flex justify-content-start align-items-center">
      <img
        fetchpriority="high"
        width="136"
        height="90"
        src="images/ai-kosh-logo.svg"
        alt="AIKosh"
        title="AIKosh"
      />
      <div class="p-3">
        <h1 class="text-2xl fw-600">Setup Your Organization</h1>
        <p class="text-sm text__gray mb-0">Step 2/2</p>
      </div>
    </div>
  </div>
  <form [formGroup]="organizationForm">
    <div class="form-container mb-5">
      <div>
        <h1 class="text-2xl fw-600 mb-2">Organization Details</h1>
        <p class="detail-desc">Update the organisation details here.</p>
      </div>
      <div class="card-container p-4 mt-4">
        <div class="row">
          <div class="col-md-6 mb-4">
            <app-dropdown-input
              label="Entity Type"
              bindLabel="key"
              bindValue="value"
              [list]="entityTypes"
              placeholder="Select Entity"
              [isRequired]="true"
              [control]="
                utilityService.$formControl(organizationForm.get('entityType')!)
              "
            ></app-dropdown-input>
          </div>
          <div class="col-md-6 mb-4">
            <app-dropdown-input
              label="Organization Sector"
              bindLabel="key"
              bindValue="value"
              [list]="sectors"
              placeholder="Select Organization Sector"
              [isRequired]="true"
              [control]="
                utilityService.$formControl(
                  organizationForm.get('organizationSector')!
                )
              "
            ></app-dropdown-input>
          </div>
          <div class="col-md-6 mb-4">
            <app-text-input
              type="text"
              inputId="organisation-name"
              label="Organization Name"
              placeholder="Enter Name"
              [isRequired]="false"
              [control]="
                utilityService.$formControl(
                  organizationForm.get('organizationName')!
                )
              "
            ></app-text-input>
          </div>
          <div class="col-md-6 mb-4">
            <app-text-input
              type="text"
              inputId="organisation-website"
              label="Organization Website"
              placeholder="Enter Url"
              [isRequired]="true"
              [control]="
                utilityService.$formControl(
                  organizationForm.get('organizationWebsite')!
                )
              "
            ></app-text-input>
          </div>
          <div class="col-12 mb-4">
            <app-text-input
              type="text"
              inputId="organisation-address"
              label="Organization Address"
              placeholder="Enter Address"
              [isRequired]="true"
              [control]="
                utilityService.$formControl(
                  organizationForm.get('organizationAddress')!
                )
              "
            ></app-text-input>
          </div>
          <div class="col-12 mb-4">
            <app-input-label
              label="Organization Logo"
              inputId="organizationLogo"
              [isRequired]="false"
            ></app-input-label>
            <div
              class="d-flex justify-content-between align-items-start gap-4 mt-3"
            >
              <div
                class="d-flex flex-column align-items-center profile-picture-conatiner"
              >
                <div
                  class="profile-picture overflow-hidden rounded-circle bg-white"
                >
                  <img
                    class="bg-white object-fit-contain"
                    fetchpriority="low"
                    width="64"
                    height="64"
                    [imgLazyLoad]="
                      uploadFileData?.['organizationLogo']?.base64 ||
                      'images/dummy-avatar.svg'
                    "
                    alt="Organisation Logo"
                  />
                </div>
                @if (uploadFileData?.["organizationLogo"]) {
                  <button
                    class="button-no-style delete-img"
                    (click)="onFileRemove('organizationLogo')"
                  >
                    <img
                      fetchpriority="high"
                      width="20"
                      height="20"
                      src="images/delete.svg"
                      alt="Delete"
                    />
                  </button>
                }
              </div>
              <div class="flex-grow-1">
                <app-upload-input
                  [mainInputControl]="
                    utilityService.$formControl(
                      organizationForm.get('organizationLogo')!
                    )
                  "
                  [controlName]="'profilePicture'"
                  [formatsAllowed]="['svg', 'png', 'gif', 'jpg', 'jpeg']"
                  (onFileUpload)="onFileUpload($event, 'organizationLogo')"
                  [fileGuideMesg]="
                    'SVG, PNG, JPG, JPEG or GIF (max 800x400px, 2MB)'
                  "
                  [maxImgWidth]="800"
                  [maxImgHeight]="400"
                  [maxFileSizeAllowed]="2000"
                >
                </app-upload-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="d-flex justify-content-between align-items-center flex-wrap flex-md-nowrap row-gap-4 row-gap-md-auto"
    >
      <div class="flex-shrink-0">
        <app-checkbox-input
          inputId="my-profile-is-agree"
          [control]="
            utilityService.$formControl(organizationForm.get('isAgreeTnc')!)
          "
          >Click to Agree on our
          <a
            class="text__green cursor-pointer text-decoration-none"
            (click)="onPrivacyPolicyClick($event)"
            >Privacy Policy</a
          >
          Policies
        </app-checkbox-input>
      </div>
      <div
        class="d-flex justify-content-end align-items-center gap-3 w-md-auto w-100"
      >
        <button
          class="form-button btn-white flex-md-grow-0 flex-grow-1"
          (click)="redirectToRegister()"
        >
          Cancel
        </button>
        <button
          class="form-button btn-secondary flex-md-grow-0 flex-grow-1"
          (click)="onUpdateProfile()"
        >
          Next
        </button>
      </div>
    </div>
  </form>
</div>
